export enum InsuranceClaimStatus {
  Filed = 'Filed',
  UnderReview = 'Under Review',
  InformationRequested = 'Information Requested',
  Rejected = 'Rejected',
  Paid = 'Paid'
}

// The enum values are the backend/status values; these are the translation keys for displaying them
export const InsuranceClaimStatusLabelKeys: Record<InsuranceClaimStatus, string> = {
  [InsuranceClaimStatus.Filed]: 'accidents.claims.statuses.filed',
  [InsuranceClaimStatus.UnderReview]: 'accidents.claims.statuses.underReview',
  [InsuranceClaimStatus.InformationRequested]: 'accidents.claims.statuses.informationRequested',
  [InsuranceClaimStatus.Rejected]: 'accidents.claims.statuses.rejected',
  [InsuranceClaimStatus.Paid]: 'accidents.claims.statuses.paid'
}